import { makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { ManageSupplierEffects } from './state/manage-supplier.effects';
import { manageSupplierFeature } from './state/manage-supplier.reducer';

export const MANAGE_SUPPLIER_STORE_PROVIDERS = {
  feature: makeEnvironmentProviders([provideState(manageSupplierFeature)]),
  effects: provideEffects(ManageSupplierEffects),
};
